module.exports = __webpack_public_path__ + "img/tzalachat_no.d469a3dc.png";